import { AppstoreFilled, PlusOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { Button, Radio, Space } from 'antd';
import React from 'react';
import { ViewType } from '../../../model/CommonModel';
import styles from './toolbar.module.scss';

type Props = {
	selectedView: ViewType;
	isUserAdmin: boolean;
	onViewChangedHandled: React.Dispatch<React.SetStateAction<ViewType>>;
	onAddNewButtonClick: () => void;
};

const Toolbar: React.FC<Props> = ({ selectedView, isUserAdmin, onViewChangedHandled, onAddNewButtonClick }) => {
	return (
		<div className={styles.container}>
			<Space>
				<Radio.Group value={selectedView} onChange={e => onViewChangedHandled(e.target.value)}>
					<Radio.Button value={ViewType.List}>
						<UnorderedListOutlined />
					</Radio.Button>
					<Radio.Button value={ViewType.Card}>
						<AppstoreFilled />
					</Radio.Button>
				</Radio.Group>
			</Space>
			<Space>
				{isUserAdmin && (
					<Button id='velocityVisionAddNewInstanceButton' type='primary' onClick={() => onAddNewButtonClick()}>
						{<PlusOutlined />} {_('New')}
					</Button>
				)}
			</Space>
		</div>
	);
};

export { Toolbar };
